const resolveThemeVar = (varName: string, fallback: string) => {
  if (typeof window === 'undefined') return fallback;
  const styles = getComputedStyle(document.documentElement);
  const val = styles.getPropertyValue(varName).trim();
  return val || fallback;
};

export const getTinymceInit = (apiBase: string) => {
  const textPrimary = resolveThemeVar('--text-primary', '#1f2937');
  const bgCard = resolveThemeVar('--bg-card', '#ffffff');
  return ({
  height: 400,
  menubar: true,
  content_style: `
    body {
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      color: ${textPrimary};
      background-color: ${bgCard};
    }
  `,
  plugins: [
    'advlist',
    'autolink',
    'lists',
    'link',
    'image',
    'media',
    'charmap',
    'preview',
    'anchor',
    'searchreplace',
    'visualblocks',
    'code',
    'fullscreen',
    'insertdatetime',
    'table',
    'help',
    'wordcount',
    'emoticons'
  ],
  toolbar:
    'undo redo | formatselect | bold italic underline forecolor backcolor | ' +
    'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | ' +
    'link image media emoticons | removeformat | code fullscreen help',
  automatic_uploads: true,
  images_upload_url: `${apiBase}/api/upload/image`,
  file_picker_types: 'image',
  file_picker_callback: (callback: any, value: any, meta: any) => {
    if (meta.filetype === 'image') {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.onchange = function () {
        const file = (input as HTMLInputElement).files?.[0];
        if (file) {
          const formData = new FormData();
          formData.append('image', file);

          fetch(`${apiBase}/api/upload/image`, {
            method: 'POST',
            body: formData,
          })
            .then((res) => res.json())
            .then((data) => {
              callback(data.imageUrl, { alt: file.name });
            })
            .catch((err) => console.error('Upload failed:', err));
        }
      };
      input.click();
    }
  }
  });
};
